<template>
  <section>
    <div class="row">
      <div class="col-8">
        <div class="row">
          <div class="col-4">
            <div class="progress">
              <div
                class="progress-bar"
                :class="{ 'bg-success': isComplete, 'progress-bar-striped progress-bar-animated': !isComplete }"
                role="progressbar"
                :style="`width: ${progress}%;`"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div class="col custom-stats">
            <span>{{ duration }}</span>
            <span class="ms-2">{{ average }}</span>
            <span class="ms-2">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col custom-list">
        <span class="custom-list-label">Success ({{ success.length }})</span>
        <ul>
          <li v-for="(item, idx) of success" :key="idx">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="col custom-list">
        <span class="custom-list-label">Failed ({{ failed.length }})</span>
        <ul>
          <li v-for="(item, idx) of failed" :key="idx">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'MatrixImportStatus',
  data() {
    return {
      progress: 0,
      duration: null,
      average: null,
      total: null,
      testInterval: null,
      isComplete: false,
      success: [],
      failed: []
    }
  },
  mounted() {
    this.reset()
    this.emitter.on('process-make-matrix-links', (status) => {
      console.log('Import Progress', status)
      this.calcProgress(status)
    })
  },
  emits: ['progress', 'isComplete'],
  methods: {
    reset() {
      this.isComplete = false
      this.success = []
      this.failed = []
      this.progress = 0
      this.duration = null
      this.average = null
      this.total = null
    },
    testProgress() {
      let cnt = 1
      this.progress = 0
      this.testInterval = setInterval(() => {
        this.progress += cnt * 10
        if (this.progress === 100) {
          clearInterval(this.testInterval)
        }
      }, 2000)
    },
    calcProgress(status) {
      this.$emit('progress', false)
      let isComplete = this.getStatus(status, 'IsComplete')
      if (isComplete) {
        if (parseInt(isComplete) === 1) {
          console.log('Import Complete')
          this.$emit('isComplete')
        }
      } else {
        let total = this.getStatus(status, 'TotalCount')
        let count = this.getStatus(status, 'Count')
        let duration = this.getStatus(status, 'TotalDuration')
        let vehicle = this.getStatus(status, 'Vehicle')
        let isFailed = this.getStatus(status, 'IsFailed')
        if (total !== null && count !== null) {
          this.progress = (parseInt(count) / parseInt(total)) * 100
        }
        if (duration) {
          if (duration > 3600) {
            this.duration = `${(duration / 3600).toFixed(1)} hours`
          } else if (duration > 60) {
            this.duration = `${(duration / 60).toFixed(1)} minutes`
          } else {
            this.duration = `${duration.toFixed(0)} seconds`
          }
        }
        if (count !== null) {
          this.total = `for ${count} of ${total} records.`
        }
        if (isFailed === 1) {
          this.failed.unshift(vehicle)
        } else {
          this.success.unshift(vehicle)
        }
        console.log('Current Progress', {
          progress: this.progress,
          duration: duration,
          vehicle: vehicle,
          total: this.total,
          isFailed: isFailed
        })
        if (this.progress >= 100) {
          this.$emit('progress', true)
          this.isComplete = true
        }
      }
    },
    getStatus(status, item) {
      let value = null
      if (status) {
        let found = status.find((x) => x.attribute === item)
        if (found) {
          value = found.data ? found.data : found.value
        }
      }
      return value
    }
  },
  beforeUnmount() {
    this.emitter.off('process-make-matrix-links')
  }
}
</script>
<style lang="scss" scoped>
.custom-list {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 250px;
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  font-size: 0.75em;
}
.custom-list-label {
  font-weight: 600;
  margin-bottom: 5px;
}
.custom-stats {
  font-size: 0.9em;
}
</style>
